import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { PlacementQuestion } from "../types/PlacementQuestion";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Typography } from "@mui/material";

type QuestionPopoverProps = {
  questions: PlacementQuestion[];
};

const QuestionPopover: React.FC<QuestionPopoverProps> = ({ questions }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <IconButton aria-describedby={id} color="primary" onClick={handleClick}>
        <OpenInNewIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <List>
          {questions.map((q, index) => (
            <ListItem
              key={index}
              sx={{
                "&:hover": {
                  backgroundColor: "action.hover",
                },
              }}
            >
              <div>
                <Typography variant="subtitle1" component="span">
                  {index + 1}. {q.question}
                </Typography>
                <Typography
                  component="div"
                  variant="body2"
                  sx={{ color: "text.secondary" }} // Make the text color lighter
                >
                  <div>Correct Answer: {q.answer}</div>
                  {q.userAnswer && (
                    <div>
                      Your Answer: {q.userAnswer}
                      {q.userAnswer === q.answer && (
                        <CheckCircleIcon color="success" />
                      )}
                    </div>
                  )}
                </Typography>
              </div>
            </ListItem>
          ))}
        </List>
      </Popover>
    </>
  );
};

export default QuestionPopover;
